module.exports = __webpack_public_path__ + "static/media/31JFA4.9a6d41a7.jpg";